(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-yys-native-tag-select]');
    if (!select || !select.value || select.value === window.location.pathname) return;
    window.location.href = select.value;
  });
  } catch(e) { console.error(e); }
})();

})();
